import {StyleProp, ViewStyle} from 'react-native';
import {ProductCategoryResponsePayload} from '../../../shared/models/api/productCategoryResponsePayload';
import {ProductAcceptorResponsePayload} from '../../../shared/models/api/productAcceptorResponsePayload';
import {ProductPriceResponsePayload} from '../../../shared/models/api/productPriceResponsePayload';
import {validationItems} from '../../login/esiaRegCard/components/form/constants';
import {ValidationItem} from '../../../shared/pipes';
import {digitsOnlyRegex} from '../../../shared/utils/text';

export interface ProductsCategoryFilterForm {
  productCategory?: boolean[];
}

export interface ProductsAcceptorFilterForm {
  productAcceptor?: boolean[];
}

export interface ProductsCategoryFilterViewBaseProps {
  onSubmit: (e?: any) => void;
  productCategories: ProductCategoryResponsePayload[] | null;
}

export interface ProductsAcceptorFilterViewBaseProps {
  onSubmit: (e?: any) => void;
  productAcceptors: ProductAcceptorResponsePayload[] | null;
}

export interface PropsProductCategoryList {
  productCategories: ProductCategoryResponsePayload[] | null;
  style?: StyleProp<ViewStyle>;
  visuallyImpaired?: boolean;
}

export interface PropsProductAcceptorList {
  productAcceptors: ProductAcceptorResponsePayload[] | null;
  style?: StyleProp<ViewStyle>;
  visuallyImpaired?: boolean;
}

export interface PropsProductPriceList {
  productPrices: ProductPriceResponsePayload | null;
  style?: StyleProp<ViewStyle>;
  visuallyImpaired?: boolean;
}

export interface ProductsPriceFilterForm {
  productPrice?: number[];
}

export const defaultFilterPrice = {
  maxPrice: 100000000,
  minPrice: 0,
};

export interface ProductsPriceFilterViewBaseProps {
  onSubmit: (e?: any) => void;
  productPrices: ProductPriceResponsePayload | null;
}

export const validationProductPriceFormItems: ValidationItem[] = [
  {
    names: 'productPrice',
    error: 'Введено некорректное значение цены. Значение установлено на данное по умолчанию.',
    type: 'custom',
    validator: (value: number[]) => {
      if (value === undefined || value.length === 0) return true;
      return value.every((price) => price >= defaultFilterPrice.minPrice && price <= defaultFilterPrice.maxPrice);
    },
  },
];
